import { apiService } from '../services/apiService';

export default {
  name: 'SearchView',
  data() {
    return {
      rssNodes: [],
      searchForm: {
        dateOperator: '=',
        date: new Date().toISOString().split('T')[0],
        startDate: '',
        endDate: '',
        rssNodeIds: [],
        keywords: '',
        categories: ''
      },
      searchResults: null,
      currentPage: 1,
      pageSize: 20,
      isLoading: false
    }
  },
  computed: {
    totalPages() {
      if (!this.searchResults) return 0;
      return Math.ceil(this.searchResults.totalItems / this.pageSize);
    },
    displayedPages() {
      if (this.totalPages <= 5) {
        // 如果总页数小于等于5，显示所有页码
        return Array.from({ length: this.totalPages }, (_, i) => i + 1);
      }

      const pages = [];
      let startPage = Math.max(1, this.currentPage - 2);
      let endPage = Math.min(this.totalPages, startPage + 4);

      // 如果当前页靠近末尾，调整起始页
      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4);
      }

      // 添加页码
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    }
  },
  mounted() {
    this.fetchRssNodes();
  },
  methods: {
    async fetchRssNodes() {
      try {
        console.log('Fetching RSS nodes...'); // 添加日志
        const response = await apiService.fetchRssNodes(this.setLoading);
        console.log('RSS nodes response:', response); // 添加日志
        
        if (Array.isArray(response)) {
          this.rssNodes = response;
          console.log('RSS nodes set:', this.rssNodes); // 添加日志
        } else {
          console.error('Invalid RSS nodes response:', response);
          this.rssNodes = [];
        }
      } catch (error) {
        console.error('Error fetching RSS nodes:', error);
        this.rssNodes = [];
      }
    },
    async search() {
      try {
        this.isLoading = true;
        const params = {
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          dateOperator: this.searchForm.dateOperator || '='  // 确保始终有默认值
        };

        // 处理日期参数
        if (this.searchForm.dateOperator === 'between') {
          params.startDate = this.searchForm.startDate;
          params.endDate = this.searchForm.endDate;
        } else {
          params.date = this.searchForm.date;
        }

        // 处理 RSS 节点 ID
        if (Array.isArray(this.searchForm.rssNodeIds) && this.searchForm.rssNodeIds.length > 0) {
          this.searchForm.rssNodeIds.forEach(id => {
            if (!params.rssNodeIds) {
              params.rssNodeIds = [];
            }
            params.rssNodeIds.push(parseInt(id));
          });
        }

        // 处理其他参数
        if (this.searchForm.keywords) {
          params.keywords = this.searchForm.keywords;
        }
        if (this.searchForm.categories) {
          params.categories = this.searchForm.categories;
        }

        console.log('Search params:', params); // 添加日志

        const response = await apiService.searchFeeds(params, this.setLoading);
        this.searchResults = response;
      } catch (error) {
        console.error('Error searching feeds:', error);
        alert('搜索失败: ' + error.message);
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.searchForm = {
        dateOperator: '=',
        date: new Date().toISOString().split('T')[0],
        startDate: '',
        endDate: '',
        rssNodeIds: [],
        keywords: '',
        categories: ''
      };
      this.searchResults = null;
      this.currentPage = 1;
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.search();
      }
    },
    getNodeName(nodeId) {
      const node = this.rssNodes.find(n => n.id === nodeId);
      return node ? node.siteName : '';
    },
    setLoading(loading) {
      this.isLoading = loading;
    }
  },
  watch: {
    'searchForm.dateOperator': {
      handler(newValue) {
        if (newValue === 'between') {
          const today = new Date();
          const threeDaysAgo = new Date(today);
          threeDaysAgo.setDate(today.getDate() - 3);
          
          this.searchForm.startDate = threeDaysAgo.toISOString().split('T')[0];
          this.searchForm.endDate = today.toISOString().split('T')[0];
        } else {
          this.searchForm.date = new Date().toISOString().split('T')[0];
        }
      },
      immediate: true
    }
  }
} 